import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { Content } from 'src/contexts/ContentContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { vars } from 'src/core/themes';
import { NoData } from 'src/tables/Table';
import { Table } from 'src/tables/TableV2/Table';
import { ContentId } from 'src/utils/constants/contentId';
import { SponsoredListingsCampaign } from 'src/WebApiController';

import { getTableColumnDefinitions } from './CampaignsTableColumnsConfig';

export type CampaignsTableProps = {
  isLoading: boolean;
  disabled?: boolean;
  campaigns: SponsoredListingsCampaign[] | null | undefined;
  onStartWork: () => void;
  onStopWork: (success: boolean) => void;
};

export const CampaignsTable: React.FC<CampaignsTableProps> = ({
  isLoading,
  disabled,
  campaigns,
  onStartWork,
  onStopWork,
}) => {
  if (isLoading) {
    return <PosSpinner />;
  }

  return campaigns?.length ? (
    <ColumnResizingContextProvider>
      <Table<SponsoredListingsCampaign>
        useVirtuoso
        actionColId={'actions'}
        data={campaigns ?? []}
        columns={getTableColumnDefinitions(onStartWork, onStopWork, disabled)}
        getRowId={(data, index) => String(data?.campaignId ?? index)}
        getItemId={(data) => String(data?.campaignId)}
        state={{
          sorting: [{ id: 'startDate', desc: false }],
        }}
      />
    </ColumnResizingContextProvider>
  ) : (
    <NoData style={{ border: `1px solid ${vars.color.borderPrimary}` }}>
      <Content id={ContentId.None} />
    </NoData>
  );
};
